import React from 'react';
import InputLabel from '../InputLabel/InputLabel.jsx';
import InputError from '../InputError/InputError.jsx';
import BaseTextArea from '../BaseTextArea/BaseTextArea.jsx';
import { Skeleton } from '../../layout/loading';

export default function TextAreaField({
  register,
  errors,
  registerOptions = {},
  name,
  placeholder = '',
  labelText = '',
  labelRightElement = null,
  maxLength,
  showCount = false,
  loading = false,
  rows = 4,
  className = '',
  currentLength,
  ...props
}) {
  if (loading) {
    return (
      <div className={className}>
        {labelText && <Skeleton variant="text" className="w-24 mb-2" />}
        <Skeleton variant="rectangular" className={`w-full rounded-md`} style={{ height: `${rows * 1.5}rem` }} />
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="flex justify-between items-center">
        <InputLabel htmlFor={name} labelRightElement={labelRightElement}>
          {labelText}
        </InputLabel>
        {showCount && maxLength && (
          <span className="text-xs text-gray-400" id={`${name}-description`}>
            {currentLength !== undefined ? `${currentLength}/` : 'Max '}{maxLength} characters
          </span>
        )}
      </div>
      <div className="mt-2">
        <BaseTextArea
          id={name}
          rows={rows}
          placeholder={placeholder}
          maxLength={maxLength}
          {...props}
          {...(register ? register(name, registerOptions) : {})}
        />
      </div>
      {errors && errors[name] && <InputError>{errors[name].message}</InputError>}
    </div>
  );
}
